import { render, staticRenderFns } from "./EmbeddedDocList.vue?vue&type=template&id=41386a2c&scoped=true"
import script from "./EmbeddedDocList.vue?vue&type=script&lang=js"
export * from "./EmbeddedDocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41386a2c",
  null
  
)

export default component.exports